import React, { useRef, useEffect, useState } from 'react';
import { gsap } from 'gsap';
import Loading from './Loading';
import { useOnViewport  } from '../hooks'

import {MOBILE_BREAKPOINT, DESKTOP_BREAKPOINT} from '../slices/ui';

const SlideImage = (props) => {
  const {image, lazy=false} = props
  let imageStyle = {};

  if (image.placeholder){
    imageStyle.backgroundImage = `url("${image.placeholder}")`;
  }

  return (
    <figure className="pwa__header__picture">
      <picture>
        <source media={`(min-width: ${MOBILE_BREAKPOINT}px) and (max-width: ${DESKTOP_BREAKPOINT}px)`} 
          srcSet={image.large}/>
        <img src={image.small} 
          alt={image.title} 
          className="pwa__header__image" 
          loading={lazy ? 'lazy' : 'eager'} 
          style={imageStyle} 
          crossOrigin="anonymous" />
      </picture>
      {image.attribution && (
        <figcaption className="pwa__header__caption">
          <a href={image.attribution_url} target="_blank" rel="noopener">
            {image.title || image.attribution}
            {image.title && (
              <>
                &nbsp; <span alt={image.attribution}>&copy;</span>
              </>
            )}
          </a>
        </figcaption>
      )}
    </figure>
  )
}

const swapImages = (imgs) => {
  const captionOut = imgs[0].getElementsByTagName('figcaption');
  const captionIn = imgs[1].getElementsByTagName('figcaption');
  const imgOut = imgs[0].getElementsByTagName('img');
  const imgIn = imgs[1].getElementsByTagName('img');
  imgs[0].setAttribute('aria-hidden', 'true');
  imgs[1].setAttribute('aria-hidden', 'false');
  imgs[1].style.visibility = 'visible';
  gsap.to(imgOut, 1, {autoAlpha:0, scale:1})
  gsap.to(imgIn, 1, {autoAlpha:1, scale:1.2})
  if (captionOut[0]){
    gsap.to(captionOut[0], 1, {x: '100%'})
  }
  if (captionIn[0]){
    gsap.to(captionIn[0], 1, {x: '0'})
  }
  imgs.push( imgs.shift() )
  return imgs
}

const SwapImages = (props) => {  
  const container = useRef();
  const timeout = useRef();
  const imgs = useRef([])
  const [isVisible, setRef] = useOnViewport({}) 

  useEffect(()=>{
    setRef(container.current)
    const imgsCurrent = Array.from(container.current.children)
    if (imgsCurrent.length > 0){
      imgsCurrent[0].setAttribute('aria-hidden', 'false');
      imgsCurrent[0].getElementsByTagName('img')[0].style.opacity = 1;
      imgsCurrent[0].getElementsByTagName('img')[0].style.visibility = 'visible';
      imgsCurrent.slice(1).map((img, idx) => {
        img.setAttribute('aria-hidden', 'true');
        img.style.visibility = 'hidden';
        img.getElementsByTagName('img')[0].style.opacity = 0;
      })
    }
    imgs.current = imgsCurrent
  }, [props.children])

  useEffect(()=>{
    if (!isVisible || imgs.current.length < 2){
      clearInterval(timeout.current);
      return
    }
    timeout.current = setInterval(()=>{
      imgs.current = swapImages(imgs.current)
    }, 3000); 
    return () => clearInterval(timeout.current)
  }, [isVisible, props.children])

  return (
    <div ref={container} className="pwa__header__slideshow fade-in delay">
      { props.children }
    </div>
  )
}


const ImagesSlideShow = React.memo((props) => {

  const images = props.images;

  if (images==undefined){
    return (
      <div className="pwa__header__slideshow fade-in delay">
        <Loading/>
      </div>
    )
  } else if (images.length==0){
    return null;
  } else {
    return (
      <SwapImages>
        { images.map((image, index) => <SlideImage image={image} key={index} lazy={index !== 0}/>) }
      </SwapImages>
    )
  };
});


export default ImagesSlideShow

